import { render, staticRenderFns } from "./LearnModifyVideo.vue?vue&type=template&id=d2de461c"
import script from "./LearnModifyVideo.vue?vue&type=script&lang=js"
export * from "./LearnModifyVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports